// extracted by mini-css-extract-plugin
export var label = "_d8-2";
export var slideContainer = "_d8-0";
export var slider = "_d8-1";